// import { createApp } from "vue";
// import App from "./App.vue";
// import router from "./router";
// import { createPinia } from "pinia";
// // import '../src/style/principal.css'
// // import '@/assets/css/principal.css'

// const app = createApp(App);
// app.use(createPinia());
// app.use(router);

// // Limpa o localStorage (logoff) ao fechar a aba/janela
// window.addEventListener("unload", () => {
//   localStorage.removeItem("cnpj");
//   // Adicione aqui outros dados de autenticação se necessário
// });

// app.mount("#app");

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import { useGlobalStore } from "@/store/useGlobalStore";
import "@/style/index.css";

// Em dev: desregistra qualquer SW antigo que possa estar interceptando chamadas à API
if (
  "serviceWorker" in navigator &&
  (location.hostname === "localhost" || location.hostname === "127.0.0.1")
) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((reg) => reg.unregister());
  });
}

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
app.use(router);

// Restaura sessão ao recarregar a página caso haja token e CNPJ válidos
const token = localStorage.getItem("token");
const cnpjSalvo = localStorage.getItem("cnpj_logado");
if (token && cnpjSalvo) {
  const store = useGlobalStore();
  store.definirCnpjLogado(cnpjSalvo);
}

// Remove chaves de cache de menus legadas para evitar dados desatualizados
localStorage.removeItem("petshop_menus");
localStorage.removeItem("petshop_menus_v2");

app.mount("#app");

// ============================================================
// SERVICE WORKER - LISTENER PARA ATUALIZAÇÃO DE CACHE
// ============================================================
// Quando o SW atualiza e limpa caches antigos, ele envia uma mensagem
// para notificar o frontend. Aqui recarregamos a página com a nova versão.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.addEventListener("message", (event) => {
    if (event.data && event.data.type === "CACHE_UPDATED") {
      console.log(
        `[Frontend] Nova versão disponível (cache v${event.data.version}). Recarregando...`,
      );

      // Mostra um toast de notificação
      try {
        const store = useGlobalStore();
        if (store.showToast) {
          store.showToast(
            "⟳ Novas funcionalidades disponíveis! Recarregando página...",
            "info",
          );
        }
      } catch (e) {
        console.log("Toast não disponível");
      }

      // Aguarda um pouco para o toast aparecer
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    }
  });

  // Registra o SW após app montar
  if (process.env.NODE_ENV === "production") {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        console.log("[SW] Registrado com sucesso", reg);
      })
      .catch((err) => {
        console.warn("[SW] Falha ao registrar:", err);
      });
  }
}

// ============================================================
// AUTO-UPDATE NOTIFICATION SYSTEM
// ============================================================
// O script no index.html detecta automaticamente novas versões a cada 5 minutos.
// Aqui habilitamos a notificação visual quando detecta mudança.
window.__showUpdateNotification = function () {
  try {
    const store = useGlobalStore();
    if (store.showToast) {
      store.showToast("🔄 Nova versão disponível! Atualizando...", "info");
    }
  } catch (e) {
    console.log("[AUTO-UPDATE] Toast não disponível, prosseguindo com reload");
  }
};
